<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Cadastro - Rateio de Energia"
    [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">
    <p class="po-font-subtitle">Verifique todos os Rateios de Energia incluídos no sistema.
    </p>
    <po-divider></po-divider>
    <div class="po-row po-mb-4 shadow">
        <div>
            <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
        </div>
        <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="false"
            [p-loading-show-more]="!isHideLoading"
            [p-spacing]="poTableColumnSpacing" p-container="border" p-hide-columns-manager="false"
            [p-columns]="columns" [p-items]="tableItens">
        </po-table>
    </div>
</po-page-list>
